module.exports = __webpack_public_path__ + "r-payments.png?2fa66b9c9130b65293eb3ad56377b390";